import { Alert, Box, Button, Container, Paper, Stack, Typography } from '@mui/material';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { signIn, error } = useAuth();

  return (
    <Container component="main" maxWidth="sm" sx={{ py: 8 }}>
      <Paper elevation={2} sx={{ p: 4 }}>
        <Stack spacing={3}>
          <Box>
            <Typography variant="h5" component="h1" gutterBottom>
              Rough Creek Campaigns
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Send a paced email campaign to a list of guests. Sign in with your Rough Creek
              account to continue.
            </Typography>
          </Box>

          {error && <Alert severity="error">{error}</Alert>}

          <Button variant="contained" size="large" onClick={() => void signIn()}>
            Sign in with Google
          </Button>
        </Stack>
      </Paper>
    </Container>
  );
}
